import CustomerActionsPage from './customer-actions-page'

import withRedux from './with-redux'

export default withRedux(CustomerActionsPage)